import { IInvoice, InvoiceStatus } from "@wingspanhq/payments/dist/interfaces";
import { useWSMutation } from "@ws-react-query";
import { useHistory } from "react-router-dom";
import { FormDataWorkLogInvoice } from ".";
import { INVOICING_PATH } from "../..";
import { attachmentsFormDataToUpdateRequest } from "../../../../Invoices/utils/invoicesFormUtils";
import { QUERY_INVOICE, QUERY_INVOICES } from "../../../../query/payments/keys";
import { paymentsService } from "../../../../services/payments";
import { WSServiceError } from "../../../../utils/serviceHelper";

export function useMutationSubmit(
  invoiceId: string,
  options?: {
    sendInvoice?: boolean;
  }
) {
  const history = useHistory();

  return useWSMutation<IInvoice, WSServiceError, FormDataWorkLogInvoice>(
    async data => {
      let invoice = await paymentsService.invoice.get(invoiceId);

      invoice = await paymentsService.invoice.update(
        invoiceId,
        {
          invoiceNotes:
            invoice.invoiceNotes === data.notes ? undefined : data.notes,
          attachments: {
            customAttachmentIds: attachmentsFormDataToUpdateRequest(
              data.attachments,
              invoice.attachments?.customAttachmentIds
            )
          }
        },
        {
          waitForRowUpdate: true
        }
      );

      if (options?.sendInvoice) {
        await paymentsService.invoice.update(
          invoiceId,
          {
            status: InvoiceStatus.Open
          },
          {
            waitForRowUpdate: true
          }
        );
      }

      return invoice;
    },
    {
      dependencies: [[QUERY_INVOICE, invoiceId], QUERY_INVOICES],
      onSuccess: invoice => {
        history.push(INVOICING_PATH + "/" + invoice.invoiceId);
      }
    }
  );
}
